import { render, staticRenderFns } from "./SuspensoesView.vue?vue&type=template&id=425e3bbf&"
import script from "./SuspensoesView.vue?vue&type=script&lang=js&"
export * from "./SuspensoesView.vue?vue&type=script&lang=js&"
import style0 from "./SuspensoesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports